import type { StoreActionApi } from 'react-sweet-state';
import type { State } from '../../types';

export const publishSuccess =
	({
		articleId,
		draftShareId,
		spaceKey,
	}: {
		articleId: string;
		draftShareId: string;
		spaceKey: string;
	}) =>
	async ({ setState, getState }: StoreActionApi<State>) => {
		setState({ ...getState(), published: true, articleId, draftShareId, spaceKey });
	};
